import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { getConfigValue } from '../../util/getConfigValue';
import { AppContext } from '../../util/AppContext';
import { computeBorderColorClass, getIndicatorClass } from '../../util/getBorderColor';
import { getSanitizedHtml } from '../../util/getSanitizedHtml';
import PlanListColumn from '../PlanListColumn';
import PropType from 'prop-types';
import { getTableColumnsSpec } from '../../util/getTableColumnsSpec.js';



PlanListModal.propTypes = {
    show: PropType.bool,
    setShow: PropType.func,
    prescriberData: PropType.object,
    displayName: PropType.string,
    showBackButton: PropType.bool,
}

function PlanListModal({ show, setShow, prescriberData, displayName, showBackButton }) {
    const [appState] = useContext(AppContext);
    const maxDisplayColumnsConfig = getConfigValue(appState.config?.PlanList?.MaxDisplayColumns, appState)?.Value;
    const maxDisplayColumns = maxDisplayColumnsConfig ? parseInt(maxDisplayColumnsConfig) : 4;
    const prescriberPlans = prescriberData?.dynamicTable;
    let columnsSpec = '1fr';
    if(prescriberPlans?.headers && window.innerWidth >= 990){ 
        columnsSpec = getTableColumnsSpec(prescriberPlans?.headers.slice(0, maxDisplayColumns));
    }
    

    return (
        <Modal show={show} className="modal-xl" onHide={() => setShow(false)} scrollable={true}>
            <Modal.Header className="primary" closeButton>
                <Modal.Title className="modal-title type-20 fs-5">{getConfigValue(appState.config?.BatchPrint?.Page?.SelectedPlans?.Title, appState)?.Value}</Modal.Title>
            </Modal.Header>
            {showBackButton ? <div
                className='d-flex justify-content-between align-items-center mb-2 '
                style={{
                    backgroundColor: "#DEE5EB",
                }}>
                <button type="button"
                    className=' btn btn-ghost btn-lg d-flex align-items-center mt-3 '
                    onClick={() => setShow(false)}>
                    <span
                        className="fa-regular fa-chevron-left btn-icon"
                        style={{ marginRight: "10px" }}>
                    </span>
                    {getConfigValue(appState.config?.BatchPrint?.Page?.BundleList?.Label, appState)?.Value}
                </button>
            </div> : ""}
            <Modal.Body className="modal-body">
                <h2 className="type-24">{getConfigValue(appState.config?.BatchPrint?.Page?.SelectedPlans?.Header, appState)?.Value} {displayName}</h2>
                <div className="alert alert-primary mt-3" role="alert">
                    <div className="alert-icon"></div>
                    <div className="alert-content">
                        <p className="m-0">{getConfigValue(appState.config?.BatchPrint?.Page?.Modal?.Alert, appState)?.Value}</p>
                    </div>
                </div>
                <div className='container-xl'>
                    <div className='row pd-plan-table-header align-items-lg-center d-none d-lg-flex py-3'>
                        <div className='pd-plan-col col-lg-12'>
                            <div className='align-items-lg-center' style={{ display: 'grid', gridTemplateColumns: `${columnsSpec}` }}>
                                {prescriberPlans?.headers.slice(0, maxDisplayColumns).map((header) => (
                                    <div key={header.key}>
                                        <div dangerouslySetInnerHTML={getSanitizedHtml(header.title)}></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {prescriberPlans?.rows.map((row) => {
                        return (
                            <div key={row.data.planId} className={`row pd-plan-table-row ${getIndicatorClass(computeBorderColorClass(row.data.isWin, row.data.isPrintable, row.data.planClass))} pd-plan-table-card align-items-lg-center py-3 py-lg-4 py-xl-5 `}>
                                <div className='pd-plan-col pd-plan-variable col-12 col-lg-12'>
                                    <div className='align-items-lg-center' style={{ display: 'grid', gridTemplateColumns: `${columnsSpec}` }}>
                                        {Object.entries(row.columns).map(([key, value], index) => {
                                            return (
                                                index < maxDisplayColumns ? <PlanListColumn key={key} index={index} value={value}/> : null
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Modal.Body>
        </Modal>

    );
}

export default PlanListModal;